import React from 'react'
import {
  Row,
  Col,
  Button,
  Card,
  Spin,
  Form,
} from 'antd';
import {
  FileTextOutlined,
  DownloadOutlined,
  DeleteOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import 'bootstrap/dist/css/bootstrap.css';

// Keep in sync with the server allowlist (BlobController.AllowedExtensions).
// Excludes text/plain (can't be content-validated) and image/svg+xml (XSS vector).
export const acceptedFiles = {
  accept: "application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, image/jpeg, image/png, image/gif, image/webp, image/bmp, image/tiff, image/avif, image/apng",
};

export const acceptedImageFiles = [
  "image/apng",
  "image/avif",
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/bmp",
  "image/tiff"
];

export const FileUpload = (props) => {
  const {
    title, desc, isRequired, isDownloading, titleStyle,
    uniqueID, friendlyName, fileType, isfileUpload,
    handleFileChange, handleDownloadFile, handleDeleteFile
  } = props;

  const clickUploadField = (e, fileType) => {
    var el = "upload-" + fileType + "-field";
    document.getElementById(el).click();
  }


  const FetchingFile = () => {
    return (
      <>
        <Card bordered={false} className="download-file-card">
          <Row>
            <Col md={4} xs={24}>
              <FileTextOutlined className="file-icon" />
            </Col>
            <Col md={20} xs={24}>
              <ul>
                <li><strong>Filename:</strong> {friendlyName}</li>
                <li>
                  <Spin /> <small>Fetching file...</small>
                </li>
              </ul>
            </Col>
          </Row>
        </Card>
      </>
    )
  }

  const FilePreview = () => {
    return (
      <>
        <Card bordered={false} className="download-file-card">
          <Row>
            <Col md={4} xs={24}>
              <FileTextOutlined className="file-icon" />
            </Col>
            <Col md={20} xs={24}>
              <ul>
                <li><strong>Filename:</strong> {friendlyName}</li>
                <li>
                  <Button type="primary" className="inline-button" icon={<DownloadOutlined />} onClick={e => handleDownloadFile(e, fileType)} htmlType="button">
                    Download
                  </Button>
                  {" "}
                  <Button type="danger" className="inline-button" icon={<DeleteOutlined />} onClick={e => handleDeleteFile(e, fileType)} htmlType="button">
                    Delete
                  </Button>
                </li>
              </ul>
            </Col>
          </Row>
        </Card>
      </>
    );
  }

  const CustomProgressBar = () => {
    return (
      <>
        <Row>
          <Col>
            <div className="progress custom-progressbar">
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: '20em' }}></div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div>
              <span><small>Uploading</small></span>
            </div>
          </Col>
        </Row>
      </>
    );
  }

  return (
    <div className="ant-form ant-form-vertical">
      <div className="ant-row ant-form-item" style={{ rowGap: "0px" }}>
        <div className="ant-col ant-form-item-label">
          <label style={titleStyle}>
            {
              isRequired ?
                (
                  <span style={{
                    display: 'inline-block',
                    marginRight: '4px',
                    color: '#ff4d4f',
                    fontSize: '14px',
                    fontFamily: 'SimSun, sans-serif',
                    lineHeight: 1,
                  }}>*</span>
                ) :
                (<></>)
            }
            {title}
          </label>
          {desc}
        </div>
        <div className="ant-col ant-form-item-control">
          {
            uniqueID ? (
              <>
                {
                  isDownloading ? (
                    <>
                      <FetchingFile type={fileType} friendlyName={friendlyName} />
                    </>
                  ) : (
                    <FilePreview type={fileType} friendlyName={friendlyName} />
                  )
                }
              </>
            ) : (
              <>
                {
                  !isfileUpload ? (
                    <Row>
                      <Col xs={24} md={10}>
                        <Form.Item
                          name={fileType}
                          label={''}
                          hasFeedback
                          rules={[
                            {
                              required: isRequired,
                              message: `${title} file is required.`
                            }
                          ]}
                          initialValue={''}
                        >
                          <Button type="primary" className="inline-button" icon={<UploadOutlined />} onClick={e => clickUploadField(e, fileType)} htmlType="button">Upload</Button>
                        </Form.Item>
                        <div className="ant-form-item-control-input">
                          <input {...acceptedFiles} className="upload-file-field" id={`upload-${fileType}-field`} type="file" name={fileType} onChange={e => handleFileChange(e)} />
                        </div>
                      </Col>
                    </Row>

                  ) : (
                    <CustomProgressBar />
                  )
                }
              </>
            )
          }
        </div>
      </div>
    </div>
  )
}





// export default FileUpload
